import { replaceAllWithPredicate } from "lib/@components/slot/replace-all-with-predicate"

export function replaceAllWithType(type, something, priority = 1000) {
    return replaceAllWithPredicate((item) => item.type === type || item.type?.name === type, something, priority)
}
